// extracted by mini-css-extract-plugin
var _1 = "JVy8pA0xbGkDbw8M1Ofz";
var _2 = "JpBSmT_63V70iIwZGZVi";
export { _1 as "checkbox", _2 as "checkboxLabel" }
